<template>
	<div>
		<div class="card">
			<div class="card-body">
				<div class="row">
					<div class="col-md-6">
						<b-form @submit="onSubmitForm" v-if="ready">
							<b-alert :show="showAlertError" variant="danger">
								<ul>
									<li v-for="(error, key) in errors" :key="key">{{ error }}</li>
								</ul>
							</b-alert>
							<fieldset class="form-group">
								<legend>Договоры</legend>
								<file-upload
									label="Юридическое лицо"
									:data="form.files"
									:typeId=2
									:accept="['application/vnd.openxmlformats-officedocument.wordprocessingml.document']"
									@upload="handleFileUpload"
									@remove="handleRemoveFile"
								/>
								<file-upload
									label="Индивидуальный предприниматель"
									:data="form.files"
									:typeId=3
									:accept="['application/vnd.openxmlformats-officedocument.wordprocessingml.document']"
									@upload="handleFileUpload"
									@remove="handleRemoveFile"
								/>
								<file-upload
									label="Физическое лицо"
									:data="form.files"
									:typeId=4
									:accept="['application/vnd.openxmlformats-officedocument.wordprocessingml.document']"
									@upload="handleFileUpload"
									@remove="handleRemoveFile"
								/>
							</fieldset>

							<fieldset class="form-group">
								<legend>Акты</legend>
								<file-upload
									label="Юридическое лицо"
									:data="form.files"
									:typeId=5
									:accept="['application/vnd.openxmlformats-officedocument.wordprocessingml.document']"
									@upload="handleFileUpload"
									@remove="handleRemoveFile"
								/>
								<file-upload
										label="Индивидуальный предприниматель"
										:data="form.files"
										:typeId=6
										:accept="['application/vnd.openxmlformats-officedocument.wordprocessingml.document']"
										@upload="handleFileUpload"
										@remove="handleRemoveFile"
									/>
								<file-upload
									label="Физическое лицо"
									:data="form.files"
									:typeId=7
									:accept="['application/vnd.openxmlformats-officedocument.wordprocessingml.document']"
									@upload="handleFileUpload"
									@remove="handleRemoveFile"
								/>
							</fieldset>
						</b-form>
					</div>
				</div>
			</div>
			<div class="card-footer">
				<div class="float-left">
					<b-button variant="primary" @click="onSubmitForm">Сохранить изменения</b-button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import FileUpload from '@/components/form/file-upload'
import eventHTTP from '@/api/modules/event/event'
export default {
	components: {
		FileUpload
	},
	data () {
		return {
			ready: false,
			showAlertError: false,
			productId: null,
			form: {
				files: []
			},
			errors: {}
		}
	},
	props: {
		id: {
			type: Number,
			required: true
		}
	},
	created () {
		this.getEvent()
	},
	methods: {
		getEvent () {
			eventHTTP.findOne(this.id, {expand: 'files'}).then((data) => {
				this.ready = true
				if (data.files.length > 0) {
					this.form.files = data.files
				}
			})
		},
		onSubmitForm (e) {
			e.preventDefault()
			const data = {
				files: this.form.files
			}
			eventHTTP.update(this.id, data).then((response) => {
				this.$notify({
					group: 'default',
					type: 'success',
					'title': 'Поздравляем!',
					text: 'Данные успешно обновлены.'
				})
			}, (response) => {
				this.$notify({
					group: 'default',
					type: 'danger',
					text: response
				})
			})
		},
		handleFileUpload (data) {
			let isset = false
			this.form.files.forEach((value, key) => {
				if (value.typeId === data.typeId) {
					isset = true
					this.form.files[key] = {
						id: data.id,
						usage_id: this.id,
						type_id: data.typeId
					}
					return false
				}
			})

			if (isset === false) this.form.files.push({id: data.id, usage_id: this.id, type_id: data.typeId})
		},
		handleRemoveFile (data) {
			this.form.files.forEach((value, key) => {
				if (parseInt(data.id) === parseInt(value.id) && parseInt(data.typeId) === parseInt(value.type_id)) {
					this.$delete(this.form.files, key)
				}
			})
		}
	}
}
</script>
<style>
.ck.ck-editor__editable, .ck.ck-focused {
	min-height: 200px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/event/update/file.vue